import React, { useState, useEffect, useCallback, useRef } from "react";
import {
  FaCheck,
  FaChevronLeft,
  FaChevronRight,
  FaTimes,
} from "react-icons/fa";
import noResultsFound from "@/assets/projectlisiting/no-results.svg";
import {
  createUser,
  fetchCity,
  fetchCompany,
  fetchCountry,
  fetchGroupsForAdmin,
  fetchProductPrices,
  fetchProducts,
  fetchState,
  fetchSubUserLicenses,
  fetchSubUsers,
  fetchViewLimitCount,
  updateViewLimitCount,
} from "../services/admin-services";
import { IoIosInformationCircle } from "react-icons/io";
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "@/components/ui/tooltip";
import { Button } from "@/components/ui/button";
import {
  Table,
  TableBody,
  TableCell,
  TableFooter,
  TableHead,
  TableHeader,
  TableRow,
} from "@/components/ui/table";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";

import {
  Select,
  SelectTrigger,
  SelectContent,
  SelectItem,
  SelectValue,
} from "@/components/ui/select";
import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from "@/components/ui/popover";
import { Checkbox } from "@/components/ui/checkbox";
import { ScrollArea, ScrollBar } from "@/components/ui/scroll-area";
import { RadioGroup, RadioGroupItem } from "@/components/ui/radio-group";

interface UserList {
  _id: string;
  accessRights?: string[];
  isPasswordSet?: boolean;
  email: string;
  status?: number;
  fullName?: string;
  phoneNumber?: string;
  companyName?: string;
  countryName?: string;
  creationDetails?: CreationDetails;
  isSubscribed?: boolean;
  role?: string;
  stripe_product?: string;
}

interface CreationDetails {
  email?: string;
  fullName?: string;
  pgCustomerId?: string;
  status?: number;
  _id?: string;
  paymentDetails?: PaymentDetails;
}
interface PaymentDetails {
  productId?: string;
  provider?: string;
}

interface Price {
  currency: string; // Required
  productId: string; // Required
  unitAmount?: string;
  recurring?: {
    interval: string;
    interval_count: number;
  };
  priceId: string; // Required
}
interface PaginationData {
  page: number;
  limit: number;
  nextPage: number;
}

interface Companies {
  name: string;
  id: number;
  country_id: [number, string];
}

// interface AvailableLicense {
//   currency: string;
//   name: string;
//   object: string;
//   price: number;
//   price_id: string;
//   product_id: string;
//   quantity: number;

// }
// import { Pagination } from '@/components/ui/pagination';
// import { Musers } from "./mockData";
import { Input } from "@/components/ui/input";
// import { Label } from "@radix-ui/react-select";
// import { Musers } from './mockData';
import { useLocation, useNavigate } from "react-router-dom";
import { useLoading } from "@/contexts/LoadingContext";
import { Label } from "@/components/ui/label";
// import { PhoneNumber } from "react-phone-number-input";
import toastService from "@/services/toastService";
import {
  AppGroups,
  Group,
  License,
} from "@/features/user-profile/organization-user/organization-users";
import { cn } from "@/lib/utils";
import { SUBSCRIPTIONS_USER_STATUS } from "@/utils/constant";
import { IoSearch } from "react-icons/io5";
import useDebounce from "@/hooks/useDebounce";
import { Pencil } from "lucide-react";
// import { fetchGroups } from "@/features/user-profile/services/organizationServices";

// import { CreationDetails } from '@/features/user-profile/organization-user/organization-users';
// import { Tooltip, TooltipProvider, TooltipTrigger } from '@/components/ui/tooltip';

const SubUserList: React.FC = () => {
  const [users, setUsers] = useState<UserList[]>([]);
  const { setLoading } = useLoading();
  const [error, setError] = useState<string | null>(null);
  const [isDialogOpen, setIsDialogOpen] = useState(false);
  const [pagination, setPagination] = useState<PaginationData>({
    page: 1,
    limit: 10,
    nextPage: -1,
  });

  const [phone, setPhone] = useState("");
  const [phoneError, setPhoneError] = useState("");
  const [company, setCompany] = useState("");
  const [paymentEmail, setPaymentEmail] = useState("");
  // const [stripeProduct, setStripeProduct] = useState("");
  const [stripePriceId, setStripePriceId] = useState("");

  const [country, setCountry] = useState("");
  const [state, setState] = useState("");
  // const [city, setCity] = useState("");
  const [fullName, setFullName] = useState("");
  const [email, setEmail] = useState("");
  const [emailError, setEmailError] = useState("");
  const [paymentEmailError, setPaymentEmailError] = useState("");
  const [productId, setProductId] = useState("");
  const [products, setProducts] = useState<{ id: string; name: string }[]>([]);
  const [countries, setCountries] = useState<string[]>([]);
  const [states, setStates] = useState<string[]>([]);
  const [userType, setUserType] = useState<string>("");

  const [hasLoaded, setHasLoaded] = useState(false);
  const [prices, setPrices] = useState<Price[]>([]);
  const [cities, setCities] = useState<string[]>([]);
  const [city, setCity] = useState("");

  const [subUsercompany, setsubUsercompany] = useState("");
  const [companies, setCompanies] = useState<Companies[]>([]);
  const [searchTerm, setSearchTerm] = useState("");
  const debouncedSearchTerm = useDebounce(searchTerm);

  // const [selectedLicense, setSelectedLicense] = useState<string[]>([]);
  // const [subUserLicensesList, setsubUserLicensesList] = useState<AvailableLicense[]>([]);
  const [licenses, setLicenses] = useState<License[]>([]);
  const [selectedLicense, setSelectedLicense] = useState<
    string | License | null
  >(null);
  const [selectedLicenseobject, setSelectedLicenseobject] = useState<
    License | undefined
  >(undefined);

  const [selectedApps, setSelectedApps] = useState<string[]>([]);
  const [appGroups, setAppGroups] = useState<{ [key: string]: Group[] }>({});
  const [selectedGroups, setSelectedGroups] = useState<
    Record<string, string | undefined>
  >({});

  const phoneRegexByCountry: Record<string, RegExp> = {
    "United States": /^\(?([0-9]{3})\)?[-.●\s]?([0-9]{3})[-.●\s]?([0-9]{4})$/, // US: 10-digit
    Canada: /^\(?([0-9]{3})\)?[-.●\s]?([0-9]{3})[-.●\s]?([0-9]{4})$/, // Canada: similar to US
  };

  const pathname = window.location.pathname; // Get the current URL path

  // Conditionally set the title based on the URL path
  const title =
    pathname === "/admin/dashboard/subscribed-users"
      ? "Subscribed Users"
      : pathname === "/admin/dashboard/all-users" ||
          pathname === "/admin/dashboard"
        ? "All Users"
        : "";
  const fetchProduct = async () => {
    // if (!hasLoaded) {
    setLoading(true);
    try {
      const response = await fetchProducts();
      // const data = await res.json()
      console.log(response?.data?.products, "line 101");

      setProducts(response?.data?.products);
      setHasLoaded(true);
    } catch (err) {
      console.error("Failed to load products:", err);
    } finally {
      setLoading(false);
    }
    // }
  };

  const [viewLimit, setViewLimit] = useState<number>(0); // initial value
  const [editMode, setEditMode] = useState<boolean>(false);
  const [tempLimit, setTempLimit] = useState<string>(String(viewLimit));
  console.log("line 224", viewLimit);

  useEffect(() => {
    const getViewLimit = async () => {
      try {
        const data = await fetchViewLimitCount();
        console.log("line 230", data?.data?.config);
        setViewLimit(data?.data?.config?.exploreScreenFreeClicksCount);
      } catch (err) {
        console.error("Error fetching view limit config", err);
      }
    };

    getViewLimit();
  }, []);

  const handleConfirm = async () => {
    const parsed = parseInt(tempLimit, 10);

    if (!isNaN(parsed) && parsed >= 0) {
      try {
        await updateViewLimitCount(parsed);
        setViewLimit(parsed);
        setEditMode(false);
      } catch (err) {
        console.error("Failed to update view limit:", err);
      }
    } else {
      toastService.error("Limit must be a positive number");
    }
  };

  useEffect(() => {
    // Clear selected apps and groups when license changes
    setFullName("");
    setEmail("");
    setPhone("");
    setProductId("");
    setPaymentEmail("");
    setProducts([]);
    setCountry("");
    setCountries([]);
    setState("");
    setStates([]);
    setCity("");
    setCities([]);
    setPrices([]);
    setCompany("");
    setCompanies([]);
    setSelectedApps([]);
    setSelectedGroups({});
  }, [userType]);
  const fetchCountryName = async () => {
    // if (!hasLoaded) {
    try {
      const response = await fetchCountry();
      // const data = await res.json()
      console.log(response?.data?.countries, "line 101");

      setCountries(response?.data?.countries);
      setHasLoaded(true);
    } catch (err) {
      console.error("Failed to load products:", err);
    }
    // }
  };

  const fetchCompanyName = async () => {
    // if (!hasLoaded) {
    try {
      const response = await fetchCompany();
      // const data = await res.json()
      console.log(response?.data, "line 174");
      setCompanies(response?.data?.companies);
      fetchCountryName();

      // setCompany(response?.data);
      setHasLoaded(true);
    } catch (err) {
      console.error("Failed to load products:", err);
    }
    // }
  };

  useEffect(() => {
    if (subUsercompany) {
      fetchLicensesList(subUsercompany);
    }
  }, [subUsercompany]);

  const toggleGroupSelection = (groupId: string, appName: string) => {
    setSelectedGroups((prev) => ({
      ...prev,
      [appName]: groupId, // Using dynamic key assignment for appName
    }));

    console.log("selected groups", selectedGroups, selectedApps);
  };

  const fetchGroupsList = useCallback(
    async (product_id: string) => {
      setLoading(true);
      try {
        const response = await fetchGroupsForAdmin({ product_id });
        const formattedGroups = response?.data?.groups.reduce(
          (acc: { [key: string]: Group[] }, app: AppGroups) => {
            acc[app.app_name] = app.groups;
            return acc;
          },
          {}
        );
        setAppGroups(formattedGroups || {});
      } catch (err) {
        console.error("Error fetching groups:", err);
      } finally {
        setLoading(false);
      }
    },
    [setLoading]
  );

  const toggleAppSelection = (appName: string) => {
    if (!selectedApps.includes(appName)) {
      setSelectedApps((prev) => [...prev, appName]);
      const group = appGroups[appName];
      setSelectedGroups((prev) => ({
        ...prev,
        [appName]: String(group[group.length - 1].group_id), // Ensure you access the correct property
      }));
    } else {
      setSelectedApps((prev) => prev.filter((a) => a !== appName));
      setSelectedGroups((prev) => ({
        ...prev,
        [appName]: undefined, // Ensure you access the correct property
      }));
    }
  };
  const fetchLicensesList = async (subUsercompany: string) => {
    // if (!hasLoaded) {
    try {
      const companyObj = companies.find(
        (company) => company.id === Number(subUsercompany)
      );

      console.log(companyObj, "line 286");
      setCountry(companyObj?.country_id[1] ?? "");

      const response = await fetchSubUserLicenses(Number(subUsercompany));
      // const data = await res.json()
      console.log(response?.data, "line 174");
      setLicenses(response?.data?.availableLicenses);
      // setsubUserLicensesList(response?.data?.availableLicenses)
      // setCompany(response?.data);

      setHasLoaded(true);
    } catch (err) {
      console.error("Failed to load products:", err);
    }
    // }
  };
  const fetchStateName = async (country: string) => {
    try {
      console.log("line 151");
      const response = await fetchState(country);
      // const data = await res.json()
      console.log(response?.data, "line 101");
      setStates(response?.data?.states);

      // setProducts(response?.data?.products);
      setHasLoaded(true);
    } catch (err) {
      console.error("Failed to load products:", err);
    }
  };
  const fetchCityName = async (country: string, state: string) => {
    // if (!hasLoaded) {
    try {
      const response = await fetchCity(country, state);
      // const data = await res.json()
      console.log(response?.data, "line 101");

      // setProducts(response?.data?.products);
      setCities(response?.data?.cities);
      setHasLoaded(true);
    } catch (err) {
      console.error("Failed to load products:", err);
    }
    // }
  };
  const location = useLocation();
  const navigate = useNavigate();

  const isSubscribedRoute = location.pathname.includes("/subscribed-users");
  const fetchUserList = useCallback(
    async (query = ""): Promise<UserList[] | []> => {
      setLoading(true);
      try {
        const params = {
          page: pagination.page,
          limit: pagination.limit,
          q: query,
          ...(isSubscribedRoute && { subscribed: true }),
        };
        if (
          pagination.page !== 1 &&
          isSubscribedRoute !== prevRouteRef.current
        ) {
          return [];
        }
        const response = await fetchSubUsers(params);
        const userList = response?.data?.users;
        setUsers(userList);
        setPagination((prev) => ({
          ...prev,
          nextPage: response?.data?.nextPage || -1,
        }));
        return userList;
      } catch (err) {
        console.error("Error fetching users:", err);
        setError(
          err instanceof Error ? err.message : "An unknown error occurred"
        );
        return [];
      } finally {
        setLoading(false);
      }
    },
    [pagination.page, pagination.limit, isSubscribedRoute, setLoading]
  );
  useEffect(() => {
    setPagination((prev) => ({
      ...prev,
      page: 1, // Always reset to page 1 when route changes
      limit: 10,
    }));
  }, [isSubscribedRoute]);

  useEffect(() => {
    let isMounted = true;

    const fetchData = async () => {
      try {
        setLoading(true);
        const userList = await fetchUserList(debouncedSearchTerm);
        if (isMounted) {
          setUsers(userList);
        }
      } finally {
        if (isMounted) {
          setLoading(false);
        }
      }
    };

    fetchData();

    return () => {
      isMounted = false;
    };
  }, [fetchUserList, debouncedSearchTerm]);

  const prevRouteRef = useRef(isSubscribedRoute);
  useEffect(() => {
    prevRouteRef.current = isSubscribedRoute;
  }, [isSubscribedRoute]);

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const validatePhone = useCallback(
    (value: string) => {
      if (!value) {
        setPhoneError("");
        return;
      }

      if (!country) {
        setPhoneError("Please select country first.");
        return;
      }

      const regex = phoneRegexByCountry[country];
      if (regex && !regex.test(value)) {
        setPhoneError(`Invalid phone number format for Selected Country.`);
      } else {
        setPhoneError("");
      }
    },
    [country, phoneRegexByCountry]
  );
  // useEffect(() => {
  //   fetchUserList().then(setUsers);
  // }, [fetchUserList]);
  useEffect(() => {
    // Clear phone error if country or phone becomes empty
    if (!phone) setPhoneError("");
    if (phone) {
      validatePhone(phone);
    }
  }, [phone, country, validatePhone]);

  useEffect(() => {
    if (!isDialogOpen) handleDialogClose();
  }, [isDialogOpen]);

  const handleDialogClose = () => {
    setUserType("");

    setEmailError("");
    setStripePriceId("");
    setPaymentEmailError("");
    setCity("");
    setIsDialogOpen(false);
    setPaymentEmail("");
    setFullName("");
    setEmail("");
    setPhone("");
    setProductId("");
    setProducts([]);
    setCountry("");
    setCountries([]);
    setState("");
    setStates([]);
    setCity("");
    setCities([]);
    setPrices([]);
    setCompany("");
    setCompanies([]);
    setSelectedApps([]);
    setSelectedGroups({});
    setLicenses([]);
    setSelectedLicense("");
    setsubUsercompany("");
    setHasLoaded(false);
  };

  if (error) {
    return (
      <div className="p-4 bg-red-100 text-red-700 rounded-md">
        Error: {error}
      </div>
    );
  }

  const handleStripePriceId = async (open: boolean) => {
    if (productId) {
      try {
        console.log(open, "line 225");
        const response = await fetchProductPrices(productId, country);
        setPrices(response?.data?.prices);
        setHasLoaded(true);
      } catch (err) {
        console.error("Failed to load stripe prices:", err);
      }
    }
  };
  const handlePageChange = (newPage: number) => {
    setPagination((prev) => ({ ...prev, page: newPage }));
  };

  const handleLimitChange = (newLimit: number) => {
    setPagination((prev) => ({ ...prev, limit: newLimit, page: 1 }));
  };
  const handleCreateUser = async () => {
    let userData: any = null;

    if (userType === "admin") {
      userData = {
        role: userType,
        fullName: fullName,
        email: email,
        companyName: company,
        // product_id: productId,
        phoneNumber: phone,
        paymentEmail: paymentEmail,
        stripePriceId: stripePriceId,
        countryName: country,
        state: state,
        city: city,
      };
    }

    if (userType === "sub_user") {
      const group_ids: number[] = Object.values(selectedGroups)
        .map((v) => Number(v))
        .filter((v): v is number => !isNaN(v) && v > 0);

      userData = {
        role: userType,
        fullName: fullName,
        email: email,
        companyId: Number(subUsercompany),
        product_id: productId,
        // stripePriceId: stripePriceId,
        phoneNumber: phone,
        countryName: country,
        state: state,
        city: city,
        group_ids: group_ids,
      };
    }

    // Optionally filter out empty/falsy values
    const cleanedUserData = Object.fromEntries(
      Object.entries(userData || {}).filter(
        ([, value]) => value !== "" && value !== null && value !== undefined
      )
    );
    console.log(cleanedUserData, "line 522");

    const response = await createUser(cleanedUserData);
    if (response.statusCode === 201) {
      toastService.success("User created successfully and payment link sent");
    }

    handleDialogClose();
    fetchUserList();
  };

  const handleRowClick = (userId: string) => {
    navigate(`/admin/dashboard/users/${userId}`);
  };

  console.log(subUsercompany, typeof subUsercompany, "line 410");

  const handleLicenseChange = (selectedId: string) => {
    console.log(selectedId, "line 286");
    setSelectedLicense(selectedId); // Ensure `setSelectedLicense` expects a string

    console.log(licenses, selectedId, "line 288");

    // Find the selected product_id dynamically
    const selectedLicenseObj = licenses.find(
      (license) => license.name.trim() === selectedId.trim()
    );
    setSelectedLicenseobject(selectedLicenseObj);

    console.log(selectedLicenseObj, "line 154");

    // Ensure product_id is always a string (default to empty string if undefined)
    const productId = selectedLicenseObj?.product_id ?? "";
    setProductId(productId);

    if (productId && selectedLicenseObj?.show_group_ids_dropdown) {
      fetchGroupsList(productId); // Use actual product_id
    }
  };

  const handleEmailChange = (e: any) => {
    const value = e.target.value;
    setEmail(value);

    const isValidEmail = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value);

    if (value === "") {
      setEmailError("");
    } else if (!isValidEmail) {
      setEmailError("Please enter a valid email address.");
    } else {
      setEmailError("");
    }
  };

  const handlePaymentEmailChange = (e: any) => {
    const Paymentvalue = e.target.value;
    setPaymentEmail(Paymentvalue);

    const isPaymentValidEmail = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(Paymentvalue);

    if (Paymentvalue === "") {
      setPaymentEmailError("");
    } else if (!isPaymentValidEmail) {
      setPaymentEmailError("Please enter a valid email address.");
    } else {
      setPaymentEmailError("");
    }
  };

  const isFormValid =
    userType &&
    fullName.trim() &&
    email.trim() &&
    country &&
    ((userType === "admin" && company.trim() && productId && stripePriceId) ||
      (userType === "sub_user" &&
        subUsercompany &&
        selectedLicense &&
        selectedApps.length > 0));

  return (
    <div className=" w-[95%] mx-auto 2xl:w-full  pl-0 2xl:pl-0  mt-0 mb-16 ">
      {users.length === 0 && !debouncedSearchTerm ? (
        <div className="flex flex-col items-center justify-center text-center">
          {/* <img src={noOrders} alt="No Users" className="w-48 h-48 mb-4" /> */}
          {/* <p className="text-gray-500">No Users Exist</p> */}
          {/* <Button className="Create-New-User bg-charcoal mt-6 rounded-md px-[41px] py-[8px]">
            Add New User
          </Button> */}
        </div>
      ) : (
        <>
          <div className="w-full mt-6 mb-5 ">
            <div className="flex justify-between items-center w-[95%] mx-auto  ">
              <div className="flex justify-center items-center gap-4">
                <h2 className="font-[Outfit] text-[24px] font-medium leading-[1.2] text-black whitespace-nowrap">
                  {title}
                </h2>
                <fieldset className="relative w-[12vw] h-[40px]">
                  <Button
                    variant="ghost"
                    size="sm"
                    className="absolute left-1 top-1/2 transform -translate-y-1/2 hover:bg-transparent hover:text-inherit focus:bg-transparent  focus:text-inherit"
                  >
                    <IoSearch size={15} />
                  </Button>

                  <Input
                    type="text"
                    placeholder="Search ..."
                    className="w-full pl-10 pr-4 py-1 h-[40px] border rounded"
                    value={searchTerm}
                    onChange={(e) => setSearchTerm(e.target.value)}
                  />
                </fieldset>
              </div>

              <div className=" flex gap-x-8">
                <div className="flex gap-2 items-center justify-center">
                  <p className="text-[16px] text-[#181818]">Free Views Limit</p>

                  {editMode ? (
                    <>
                      <input
                        type="number"
                        value={tempLimit}
                        onChange={(e) => setTempLimit(e.target.value)}
                        className="w-20 px-2 py-1 border border-gray-300 rounded text-sm"
                      />
                      <button
                        onClick={() => setEditMode(false)}
                        className="text-red-600 hover:text-red-800 transition-colors mr-1"
                        aria-label="Cancel edit"
                      >
                        <FaTimes className="w-4 h-5" />
                      </button>
                      <button
                        onClick={handleConfirm}
                        className="text-green-600 hover:text-green-800  transition-colors"
                        aria-label="Confirm edit"
                      >
                        <FaCheck className="w-4 h-5" />
                      </button>
                    </>
                  ) : (
                    <>
                      <span className="text-black text-[24px] font-semibold">
                        {viewLimit}
                      </span>
                      <button
                        onClick={() => {
                          setTempLimit(String(viewLimit));
                          setEditMode(true);
                        }}
                        className="ml-1 text-gray-500 hover:text-gray-700 transition-colors"
                        aria-label="Edit value"
                      >
                        <Pencil className="h-4 w-4" />
                      </button>
                    </>
                  )}
                </div>
                <Button
                  size="sm"
                  className="Create-New-User mb-3 font-medium bg-charcoal text-left h-[40px]  rounded-md px-[20px] "
                  onClick={() => setIsDialogOpen(true)}
                >
                  Add New User
                </Button>
              </div>
            </div>
            <div className=" border-t w-full mx-auto border-[#e4e4e4]" />
          </div>

          {users.length === 0 ? (
            debouncedSearchTerm ? (
              // Show "No Templates Found" when search is active
              <div className="w-full flex justify-center items-center mt-20">
                <div className="flex flex-col items-center text-center">
                  <img
                    src={noResultsFound}
                    alt="No results found"
                    className="w-40 h-40 2xl:w-80 2xl:h-80"
                  />
                  <p className="text-[#181818] text-lg font-medium">
                    No Users Found
                  </p>
                  <p className="text-gray-500 text-sm mt-2">
                    It looks like there are no users matching your search
                    criteria.
                  </p>
                </div>
              </div>
            ) : (
              // Show "No Users Exist" when no search filter
              <div className="flex justify-center items-center h-64">
                <p className="text-gray-500 text-lg">No Users Exist</p>
              </div>
            )
          ) : (
            <div className="border mt-2 ml-8 w-[95%] mx-auto  rounded-lg  border-20 border-[#e5e7eb] overflow-hidden ">
              <Table className=" rounded-lg">
                <TableHeader className="bg-[#f9f9f9]  border-20">
                  <TableRow className="border-[#e5e7eb]">
                    <TableHead className="p-3 text-black text-left font-medium">
                      Name
                    </TableHead>
                    {/* <TableHead className="p-3 text-black text-left font-medium">Role</TableHead> */}
                    <TableHead className="p-3 text-black text-left font-medium">
                      Email
                    </TableHead>
                    <TableHead className="p-3 text-black text-left font-medium">
                      Phone
                    </TableHead>
                    <TableHead className="p-3 text-black text-left font-medium">
                      Access Rights
                    </TableHead>
                    <TableHead className="p-3 text-black text-left font-medium">
                      Company
                    </TableHead>
                    <TableHead className="p-3 text-black text-left font-medium">
                      Country
                    </TableHead>
                    <TableHead className="p-3 text-black text-center font-medium">
                      Subscription Status
                    </TableHead>
                    <TableHead className="p-3 text-black text-center font-medium">
                      Password Set
                    </TableHead>
                  </TableRow>
                </TableHeader>

                <TableBody className="text-[#181818] font-[outfit] text-[14px] ">
                  {users.map((user) => (
                    <TableRow
                      key={user._id}
                      className="hover:bg-gray-100 cursor-pointer  border-[#e5e7eb]"
                      onClick={() => handleRowClick(user._id)}
                    >
                      <TableCell className="p-3 text-start text-[14px] leading-[24px] tracking-[0.3px]">
                        <div className="flex items-center gap-2 whitespace-nowrap">
                          <span>{user.fullName ? user.fullName : "--"}</span>
                          {user?.role === "admin" && (
                            <span className="px-3 py-0.5 rounded-full bg-[#f6f6f6] text-[#28af4a] text-[12px] font-medium">
                              Admin
                            </span>
                          )}
                          {user?.role === "subUser" && (
                            <span className="px-3 py-0.5 rounded-full bg-[#f6f6f6] text-[#28af4a] text-[12px] font-medium">
                              Sub User
                            </span>
                          )}
                        </div>
                      </TableCell>

                      <TableCell
                        className="p-3 text-start text-[14px]"
                        title={user.email}
                      >
                        {user.email?.length > 20
                          ? `${user.email.slice(0, 20)}...`
                          : user.email || "--"}
                      </TableCell>

                      <TableCell className="p-3 text-start text-[14px]">
                        {user.phoneNumber || "--"}
                      </TableCell>
                      <TableCell className="p-3 text-start text-[14px]">
                        <div className="flex gap-2 flex-wrap">
                          {user.accessRights && user.accessRights.length > 0 ? (
                            user.accessRights.map((right, index) => {
                              const colorMap: Record<string, string> = {
                                Explore: "bg-blue-100 text-blue-800",
                                Crm: "bg-green-100 text-green-800",
                                Calendar: "bg-[#ffeded] text-[#cd7676]",
                              };

                              const colorClass =
                                colorMap[right] || "bg-gray-100 text-gray-800";

                              return (
                                <span
                                  key={index}
                                  className={`px-2 py-1 rounded-full text-xs font-medium ${colorClass}`}
                                >
                                  {right}
                                </span>
                              );
                            })
                          ) : (
                            <span className="text-gray-500 text-sm">-</span>
                          )}
                        </div>
                      </TableCell>

                      <TableCell className="p-3 text-start text-[14px]">
                        {user.companyName || "--"}
                      </TableCell>

                      <TableCell className="p-3 text-start text-[14px]">
                        {user.countryName || "--"}
                      </TableCell>
                      <TableCell className="p-3 text-center text-[14px] leading-[24px] tracking-[0.3px]">
                        {user?.status !== undefined ? (
                          <span
                            className={
                              user.status === SUBSCRIPTIONS_USER_STATUS.ACTIVE
                                ? "text-green-600 font-medium"
                                : user.status ===
                                    SUBSCRIPTIONS_USER_STATUS.INACTIVE
                                  ? "text-red-600 font-medium"
                                  : user.status ===
                                      SUBSCRIPTIONS_USER_STATUS.ARCHIVED
                                    ? "text-yellow-600 font-medium"
                                    : user.status ===
                                        SUBSCRIPTIONS_USER_STATUS.DELETED
                                      ? "text-gray-500 font-medium"
                                      : "text-black"
                            }
                          >
                            {user.status === SUBSCRIPTIONS_USER_STATUS.ACTIVE
                              ? "Active"
                              : user.status ===
                                  SUBSCRIPTIONS_USER_STATUS.INACTIVE
                                ? "Inactive"
                                : user.status ===
                                    SUBSCRIPTIONS_USER_STATUS.ARCHIVED
                                  ? "Archived"
                                  : user.status ===
                                      SUBSCRIPTIONS_USER_STATUS.DELETED
                                    ? "Deleted"
                                    : "-"}
                          </span>
                        ) : (
                          "-"
                        )}
                      </TableCell>
                      <TableCell className="p-3 text-center text-[14px]">
                        {user.isPasswordSet ? "Yes" : "No"}
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>

                {/* Footer row with rounded bottom */}
                <TableFooter className="bg-white ">
                  <TableRow className=" rounded-lg">
                    <TableCell colSpan={6} className="p-4 rounded-lg">
                      <div className="flex justify-between items-center ">
                        <div>
                          <span className="text-gray-700 font-medium mr-2">
                            Show result:
                          </span>
                          <select
                            value={pagination.limit}
                            onChange={(e) =>
                              handleLimitChange(Number(e.target.value))
                            }
                            className="p-1 border rounded-md"
                          >
                            <option value="10">10</option>
                            <option value="25">25</option>
                            <option value="50">50</option>
                            <option value="100">100</option>
                          </select>
                        </div>

                        <div className="flex items-center space-x-4">
                          <Button
                            variant="outline"
                            disabled={pagination.page === 1}
                            onClick={() =>
                              handlePageChange(pagination.page - 1)
                            }
                          >
                            <FaChevronLeft />
                          </Button>
                          <span className="text-gray-700 font-medium">
                            Page {pagination.page}
                          </span>
                          <Button
                            variant="outline"
                            disabled={pagination.nextPage === -1}
                            onClick={() =>
                              handlePageChange(pagination.page + 1)
                            }
                          >
                            <FaChevronRight />
                          </Button>
                        </div>
                      </div>
                    </TableCell>
                  </TableRow>
                </TableFooter>
              </Table>
            </div>
          )}
        </>
      )}
      <Dialog modal={false} open={isDialogOpen} onOpenChange={setIsDialogOpen}>
        {isDialogOpen && (
          <section className="fixed inset-0 bg-black/70 z-[50]">
            <DialogContent className="max-w-2xl p-0 flex flex-col  rounded-xl  bg-white">
              <DialogHeader className="bg-[#f4f4f4] text-[#202b49] px-6 py-4 ">
                <DialogTitle className="text-xl font-semibold text-black">
                  Add New User
                </DialogTitle>
              </DialogHeader>

              <div className="grid grid-cols-3 px-6 gap-4">
                <div className="flex flex-col">
                  <label className="mb-1 text-sm font-medium text-[#616161]">
                    Type of User <span className="text-red-500">*</span>
                  </label>
                  <Select value={userType} onValueChange={setUserType}>
                    <SelectTrigger
                      className="p-2 text-sm border rounded-md h-[40px]
                    bg-white data-[placeholder]:text-[#828282] focus:ring-slate-300"
                    >
                      <SelectValue placeholder="Select User Type" />
                    </SelectTrigger>
                    <SelectContent className="focus:outline-none">
                      <SelectItem value="admin">Admin</SelectItem>
                      <SelectItem value="sub_user">Sub User</SelectItem>
                    </SelectContent>
                  </Select>
                </div>

                <div className="flex flex-col">
                  <Label className="mb-1 text-sm text-[#616161] font-medium ">
                    Name <span className="text-red-500">*</span>
                  </Label>
                  <Input
                    placeholder="Contact Name"
                    className="p-2 text-sm border rounded-md h-[40px] focus:ring-slate-300 placeholder:text-[14px] placeholder:text-[#828282]"
                    value={fullName}
                    onChange={(e) => setFullName(e.target.value)}
                  />
                </div>

                <div className="flex flex-col">
                  <label className="mb-1 text-sm font-medium text-[#616161]">
                    Email <span className="text-red-500">*</span>
                  </label>
                  <Input
                    placeholder="Enter Email"
                    className={cn(
                      "p-2 text-sm border rounded-md h-[40px] placeholder:text-[#828282]",
                      emailError && ""
                    )}
                    value={email}
                    onChange={handleEmailChange}
                  />
                  {emailError && (
                    <span className="text-red-500 text-xs mt-1">
                      {emailError}
                    </span>
                  )}
                </div>

                <div className="flex flex-col">
                  <label className="mb-1 text-sm font-medium text-[#616161]">
                    Country <span className="text-red-500">*</span>
                  </label>
                  <Select
                    value={country}
                    onValueChange={setCountry}
                    onOpenChange={fetchCountryName}
                  >
                    <SelectTrigger
                      className="p-2 text-sm border h-[40px] rounded-md
                    bg-white  data-[placeholder]:text-[#828282] focus:ring-slate-300"
                    >
                      <SelectValue placeholder="Select Country" />
                    </SelectTrigger>
                    <SelectContent>
                      {countries.length > 0 ? (
                        countries.map((c) => (
                          <SelectItem key={c} value={c}>
                            {c}
                          </SelectItem>
                        ))
                      ) : (
                        <SelectItem value="__loading" disabled>
                          {hasLoaded ? "No countries found" : "Loading..."}
                        </SelectItem>
                      )}
                    </SelectContent>
                  </Select>
                </div>

                {userType === "admin" && (
                  <>
                    <div className="flex flex-col">
                      <label className="mb-1 text-sm font-medium text-gray-600">
                        Company <span className="text-red-500">*</span>
                      </label>
                      <Input
                        placeholder="Company Name"
                        className="p-2 text-[14px] border rounded-md h-[40px] placeholder:text-[14px] placeholder:text-[#828282]"
                        value={company}
                        onChange={(e) => setCompany(e.target.value)}
                      />
                    </div>
                  </>
                )}

                <div className="flex flex-col">
                  <label className="mb-1 text-sm font-medium text-[#616161]">
                    Phone
                  </label>
                  <Input
                    placeholder="Enter Phone"
                    className="p-2 text-sm border rounded-md h-[40px] placeholder:text-[#828282]"
                    value={phone}
                    onChange={(e) => {
                      const value = e.target.value;
                      setPhone(value);
                      validatePhone(value);
                    }}
                  />
                  {phoneError && (
                    <span className="text-xs text-red-500 mt-1">
                      {phoneError}
                    </span>
                  )}
                </div>

                {userType === "sub_user" && (
                  <>
                    <div className="flex flex-col">
                      <label className="mb-1 text-sm font-medium text-[#616161]">
                        Company <span className="text-red-500">*</span>
                      </label>
                      <Select
                        value={subUsercompany}
                        onValueChange={setsubUsercompany}
                        onOpenChange={fetchCompanyName}
                      >
                        <SelectTrigger className="p-2 text-sm border rounded-md h-[40px] bg-white data-[placeholder]:text-[#828282] focus:ring-slate-300">
                          <SelectValue
                            placeholder="Select Company"
                            className="placeholder:text-[#828282]"
                          />
                        </SelectTrigger>
                        <SelectContent className="max-h-[200px] overflow-y-auto focus:outline-none">
                          {companies.length > 0 ? (
                            companies.map((company) => (
                              <SelectItem
                                key={company.id}
                                value={String(company.id)}
                              >
                                {company.name}
                              </SelectItem>
                            ))
                          ) : (
                            <SelectItem value="__loading" disabled>
                              {hasLoaded ? "No Companies  found" : "Loading..."}
                            </SelectItem>
                          )}
                        </SelectContent>
                      </Select>
                    </div>
                    {subUsercompany && (
                      <div className="flex flex-col ">
                        <label className="mb-1 text-sm font-medium text-[#616161]">
                          License <span className="text-red-500">*</span>
                        </label>
                        <Select
                          onValueChange={handleLicenseChange}
                          value={selectedLicense ? String(selectedLicense) : ""}
                        >
                          <SelectTrigger
                            className="p-2 text-sm border rounded-md h-[40px] bg-white
                          data-[placeholder]:text-[#828282] focus:ring-slate-300"
                          >
                            <SelectValue placeholder="Select License" />
                          </SelectTrigger>
                          <SelectContent className="max-h-[200px] overflow-y-auto">
                            {licenses.length > 0 ? (
                              licenses.map((license) => (
                                <SelectItem
                                  key={license.id}
                                  value={license.name}
                                  disabled={license.quantity === 0}
                                >
                                  {license.name} (Quantity: {license.quantity})
                                </SelectItem>
                              ))
                            ) : (
                              <SelectItem value="__loading" disabled>
                                {hasLoaded ? "No Licenses found" : "Loading..."}
                              </SelectItem>
                            )}
                          </SelectContent>
                        </Select>
                      </div>
                    )}
                    {selectedLicenseobject?.show_group_ids_dropdown && (
                      <div className="flex flex-col ">
                        <label className="mb-1 text-sm font-medium text-[#616161]]">
                          Select Groups <span className="text-red-500">*</span>
                        </label>
                        <Popover>
                          <PopoverTrigger
                            asChild
                            className="focus:ring-slate-300"
                          >
                            <div className="p-2 border rounded-md text-[] bg-white cursor-pointer data-[placeholder]:text-[#828282]">
                              {selectedApps.length === 0 ? (
                                <span className="text-[#828282]">
                                  Select Groups
                                </span>
                              ) : (
                                <div className="flex flex-wrap gap-1">
                                  {selectedApps.map((app) => {
                                    const groupId = selectedGroups[app];
                                    const group = appGroups[app]?.find(
                                      (g) => String(g.group_id) === groupId
                                    );
                                    return (
                                      <span
                                        key={app}
                                        className="bg-gray-100 px-2 py-1 rounded text-sm text-gray-800"
                                      >
                                        {app}
                                        {group ? ` (${group.group_name})` : ""}
                                      </span>
                                    );
                                  })}
                                </div>
                              )}
                            </div>
                          </PopoverTrigger>
                          <PopoverContent
                            className="w-80 z-[100]"
                            onClick={(e) => {
                              e.stopPropagation();
                              e.preventDefault();
                            }}
                            tabIndex={0}
                            asChild
                          >
                            <ScrollArea className="h-[200px]">
                              {Object.keys(appGroups).map((appName) => {
                                const appGroupList = appGroups[appName];
                                const lastGroup =
                                  appGroupList[appGroupList.length - 1]; // Get the last group

                                return (
                                  <div
                                    key={appName}
                                    className="mb-2"
                                    onClick={(e) => e.stopPropagation()}
                                  >
                                    <label className="flex cursor-pointer items-center space-x-2">
                                      <Checkbox
                                        checked={selectedApps.includes(appName)}
                                        onCheckedChange={() => {
                                          toggleAppSelection(appName);
                                          if (
                                            !selectedApps.includes(appName) &&
                                            lastGroup
                                          ) {
                                            toggleGroupSelection(
                                              String(lastGroup.group_id),
                                              appName
                                            );
                                          }
                                        }}
                                      />
                                      <span className="font-semibold">
                                        {appName}
                                      </span>
                                    </label>

                                    {selectedApps.includes(appName) && (
                                      <RadioGroup
                                        name={appName + "-radio-group"}
                                        value={selectedGroups[appName]} // Only one group can be selected
                                        onValueChange={(value) =>
                                          toggleGroupSelection(value, appName)
                                        }
                                      >
                                        {appGroupList.map((group, ind) => (
                                          <div
                                            key={ind}
                                            className="ml-4 flex items-center space-x-2"
                                          >
                                            <RadioGroupItem
                                              id={String(group.group_id)}
                                              value={String(group.group_id)}
                                            />
                                            <label
                                              htmlFor={String(group.group_id)}
                                              className="!cursor-pointer"
                                            >
                                              {group.group_name}
                                            </label>
                                          </div>
                                        ))}
                                      </RadioGroup>
                                    )}
                                  </div>
                                );
                              })}
                              <ScrollBar />
                            </ScrollArea>
                          </PopoverContent>
                        </Popover>
                      </div>
                    )}

                    {/* <div className="flex flex-col">
                      <label className="mb-1 text-sm font-medium text-gray-600">
                        Groups
                      </label>
                      <Select

                      >
                        <SelectTrigger className="p-2 text-sm border rounded-md h-[40px] bg-white data-[placeholder]:text-[#828282]">
                          <SelectValue placeholder="Select Groups" className="placeholder:text-[#828282]" />
                        </SelectTrigger>
                        <SelectContent>

                        </SelectContent>
                      </Select>
                    </div> */}
                  </>
                )}

                {userType === "admin" && (
                  <>
                    <div className="flex flex-col">
                      <label className="mb-1 text-sm font-medium flex gap-x-1 items-center text-gray-600">
                        Stripe Product <span className="text-red-500">*</span>
                        <TooltipProvider>
                          <Tooltip>
                            <TooltipTrigger asChild>
                              <span className="cursor-pointer">
                                <IoIosInformationCircle />
                              </span>
                            </TooltipTrigger>
                            <TooltipContent>
                              Select the country first.
                            </TooltipContent>
                          </Tooltip>
                        </TooltipProvider>
                      </label>
                      <Select
                        value={productId}
                        disabled={!country}
                        onValueChange={setProductId}
                        onOpenChange={fetchProduct}
                      >
                        <SelectTrigger
                          className="p-2 text-sm border h-[40px] 
                        rounded-md  data-[placeholder]:text-[#828282] focus:ring-slate-300"
                        >
                          <SelectValue placeholder="Select Stripe Product" />
                        </SelectTrigger>
                        <SelectContent>
                          {products.length > 0 &&
                            products.map((product) => (
                              <SelectItem key={product.id} value={product.id}>
                                {product.name}
                              </SelectItem>
                            ))}
                        </SelectContent>
                      </Select>
                    </div>

                    <div className="flex flex-col">
                      <label className="mb-1 text-sm font-medium flex items-center gap-x-1 text-gray-600">
                        Stripe Price ID <span className="text-red-500">*</span>
                        <TooltipProvider>
                          <Tooltip>
                            <TooltipTrigger asChild>
                              <span className="cursor-pointer">
                                <IoIosInformationCircle />
                              </span>
                            </TooltipTrigger>
                            <TooltipContent>
                              Select the stripe product first.
                            </TooltipContent>
                          </Tooltip>
                        </TooltipProvider>
                      </label>
                      <Select
                        value={stripePriceId}
                        onValueChange={setStripePriceId}
                        onOpenChange={handleStripePriceId}
                        // disabled={!productId}
                      >
                        <SelectTrigger
                          className="p-2 text-sm border h-[40px] rounded-md bg-white
                          data-[placeholder]:text-[#828282] focus:ring-slate-300 "
                          disabled={!productId}
                        >
                          <SelectValue
                            placeholder={
                              productId
                                ? "Select Price"
                                : "Select Product First"
                            }
                            className="placeholder:text-[#828282]"
                          />
                        </SelectTrigger>
                        <SelectContent>
                          {prices.length > 0 ? (
                            prices.map((price, index) => (
                              <SelectItem
                                key={price.priceId ?? index}
                                value={price.priceId ?? ""}
                              >
                                {`${price.currency?.toUpperCase() ?? "N/A"} ${price.unitAmount ?? ""} ${
                                  price.recurring?.interval
                                    ? `( ${price.recurring.interval_count} ${price.recurring.interval}${price.recurring.interval_count > 1 ? "s" : ""})`
                                    : ""
                                }`}
                              </SelectItem>
                            ))
                          ) : (
                            <SelectItem value="__loading" disabled>
                              {hasLoaded ? "No prices found" : "Loading..."}
                            </SelectItem>
                          )}
                        </SelectContent>
                      </Select>
                    </div>
                  </>
                )}

                {userType === "admin" && (
                  <>
                    <div className="flex flex-col">
                      <label className="mb-1 text-sm font-medium flex items-center gap-x-1 text-gray-600">
                        Payment Email
                        <TooltipProvider>
                          <Tooltip>
                            <TooltipTrigger asChild>
                              <span className="cursor-pointer">
                                <IoIosInformationCircle className="" />
                              </span>
                            </TooltipTrigger>
                            <TooltipContent>
                              The payment link will be sent to this email
                            </TooltipContent>
                          </Tooltip>
                        </TooltipProvider>
                      </label>

                      <Input
                        placeholder="Enter Payment Email"
                        className={cn(
                          "p-2 text-sm border rounded-md h-[40px] placeholder:text-[#828282]",
                          paymentEmailError && ""
                        )}
                        value={paymentEmail}
                        onChange={handlePaymentEmailChange}
                      />
                      {paymentEmailError && (
                        <span className="text-red-500 text-xs mt-1">
                          {paymentEmailError}
                        </span>
                      )}
                    </div>
                  </>
                )}

                <div className="flex flex-col">
                  <label className="mb-1 text-sm font-medium flex items-center gap-x-1 text-gray-600">
                    State
                    <TooltipProvider>
                      <Tooltip>
                        <TooltipTrigger asChild>
                          <span className="cursor-pointer">
                            <IoIosInformationCircle />
                          </span>
                        </TooltipTrigger>
                        <TooltipContent side="top" className="z-[1000] ">
                          Select the country first.
                        </TooltipContent>
                      </Tooltip>
                    </TooltipProvider>
                  </label>
                  <Select
                    value={state}
                    onValueChange={setState}
                    onOpenChange={(open) => {
                      if (open && country) {
                        console.log("Calling fetchStateName with:", country);
                        fetchStateName(country);
                      } else {
                        console.log(
                          "Dropdown closed or country not selected yet."
                        );
                      }
                    }}
                    disabled={!country}
                  >
                    <SelectTrigger className="p-2 text-sm border h-[40px] rounded-md bg-white  data-[placeholder]:text-[#828282] focus:ring-slate-300 ">
                      <SelectValue placeholder="Select State" />
                    </SelectTrigger>
                    <SelectContent className="max-h-[200px] overflow-y-auto">
                      {states.length > 0 ? (
                        states.map((s) => (
                          <SelectItem key={s} value={s}>
                            {s}
                          </SelectItem>
                        ))
                      ) : (
                        <SelectItem value="__loading" disabled>
                          {hasLoaded ? "No states found" : "Loading..."}
                        </SelectItem>
                      )}
                    </SelectContent>
                  </Select>
                </div>

                <div className="flex flex-col">
                  <label className="mb-1 text-sm font-medium flex items-center gap-x-1 text-gray-600">
                    City
                    <TooltipProvider>
                      <Tooltip>
                        <TooltipTrigger asChild>
                          <span className="cursor-pointer">
                            <IoIosInformationCircle className="" />
                          </span>
                        </TooltipTrigger>
                        <TooltipContent className="z-[1000]">
                          Select the state first.
                        </TooltipContent>
                      </Tooltip>
                    </TooltipProvider>
                  </label>
                  <Select
                    value={city}
                    onValueChange={setCity}
                    onOpenChange={(open) => {
                      if (open && state) {
                        fetchCityName(country, state);
                      }
                    }}
                    disabled={!state}
                  >
                    <SelectTrigger
                      className="p-2 text-sm border h-[40px] rounded-md bg-white
                        data-[placeholder]:text-[#828282] focus:ring-slate-300"
                    >
                      <SelectValue placeholder="Select City" />
                    </SelectTrigger>
                    <SelectContent>
                      {cities.map((c) => (
                        <SelectItem key={c} value={c}>
                          {c}
                        </SelectItem>
                      ))}
                    </SelectContent>
                  </Select>
                </div>
              </div>

              <div className="flex justify-end px-6 space-x-4 my-6">
                <Button
                  variant="secondary"
                  onClick={() => setIsDialogOpen(false)}
                  className="h-[40px] px-6 py-1"
                >
                  Cancel
                </Button>
                <Button
                  className="bg-[#181818] h-[40px] text-white px-6 py-1"
                  onClick={handleCreateUser}
                  disabled={!isFormValid}
                >
                  Add
                </Button>
              </div>
            </DialogContent>
          </section>
        )}
      </Dialog>
    </div>
  );
};

export default SubUserList;
